import agenciesService from "@/api/rindat-api/agencies.service";
import stationDataService from "@/api/rest-telemetric/station-data.service";
import lightningCounterService from "@/api/rindat-api/lightning-counter.service";
import { snackbar } from "@/core/controller/snackbar_controller";
import moment from "moment";

const state = {
  agencies: [],
  agenciesLightningCount: [],
  agencieStationData: [],
  agencieStationDataLoading: false,
  lightningLoadingAgencie: false
};

const mutations = {
  setAgencies(state, data) {
    state.agencies = data ? data : [];
  },
  setAgenciesLightningCount(state, data) {
    data.map((el => {
      state.agencies.forEach(elState => {
        if (el.agencyId == elState.id) {
          el.name = elState.id;
        }
      })
    }))
    state.agenciesLightningCount = data ? data : [];
  },
  setAgencieStationData(state, data) {
    state.agencieStationData = data ? data : [];
  },
  setAgencieStationLoading(state, data) {
    state.agencieStationDataLoading = data;
  },

  setAgencieLightningLoading(state, data) {
    state.lightningLoadingAgencie = data;
  },
};

const actions = {
  async fetchAgencies({ commit }) {
    try {
      const response = await agenciesService.getAllAgencies()
      const agencies = response.data
      agencies.sort((a, b) => a.name.localeCompare(b.name))
      agencies.forEach(el => {
        el.name = el.name.toLowerCase();
        el.name = el.name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      })
      agencies.sort(function(a, b) {
        let keyA = a.regionalId, keyB = b.regionalId;
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });

      const init_DOCCMN = agencies.findIndex((e) => e.regionalId == 88)
      agencies.splice(init_DOCCMN, 0, { divider: true }, { header: 'DOCCMN' });
      
      const init_DOCCSL = agencies.findIndex((e) => e.regionalId == 89)
      agencies.splice(init_DOCCSL, 0, { divider: true }, { header: 'DOCCSL' });

      const init_DOCMSL = agencies.findIndex((e) => e.regionalId == 90)
      agencies.splice(init_DOCMSL, 0, { divider: true }, { header: 'DOCMSL' });

      const init_DOCNRO = agencies.findIndex((e) => e.regionalId == 91)
      agencies.splice(init_DOCNRO, 0, { divider: true }, { header: 'DOCNRO' });

      const init_DOCNRT = agencies.findIndex((e) => e.regionalId == 92)
      agencies.splice(init_DOCNRT, 0, { divider: true }, { header: 'DOCNRT' });

      const init_DOCOST = agencies.findIndex((e) => e.regionalId == 93)
      agencies.splice(init_DOCOST, 0, { divider: true }, { header: 'DOCOST' });

      const init_DOCSUD = agencies.findIndex((e) => e.regionalId == 94)
      agencies.splice(init_DOCSUD, 0, { divider: true }, { header: 'DOCSUD' });

      commit('setAgencies', agencies);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Erro",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchAgenciesLightningCount({ commit }, data) {
    commit("setAgencieLightningLoading", true)
    const ids = []
    data.forEach(el => {
      ids.push(el.id)
    });
    const response = await lightningCounterService.getAgenciesLightningCounter(ids.toString(), moment().utc().toISOString(), 60)
    commit('setAgenciesLightningCount', response.data);
    commit("setAgencieLightningLoading", false)

  },
  async fetchAgencieStationData({ commit }, data) {
    commit('setAgencieStationLoading', true);
    const ids = [];
    data.forEach(el => {
      ids.push(el.id)
    });
    const response = await stationDataService.getAgencieStationData(ids.toString())
    let res = response.data;
    let array = [];
    if (res && res.length > 0) {
      res.forEach((el1) => {
        res.forEach((el2) => {
          if (el1.agencyIds && el2.agencyIds && (el1.agencyIds[0] == el2.agencyIds[0])) {
            if (!array.some((el) => el.name == el1.agencyIds[0])) {
              array.push({
                name: el1.agencyIds[0],
                alerts: [],
              });
            }
          }
        });
      });
      res.forEach((el1) => {
        array.map((el2) => {
          if (el1.agencyIds && (el1.agencyIds[0] == el2.name)) {
            if(el1.windGust){
              el2.alerts.push(el1);
            }
          }
        });
      });

      commit('setAgencieStationData', array);
    }
    commit('setAgencieStationLoading', false);
  }
};

const getters = {
  agenciesList: (state) => state.agencies,
  agenciesLightningCountList: (state) => state.agenciesLightningCount,
  agencieStationDataList: (state) => state.agencieStationData,
  agencieStationDataLoading: (state) => state.agencieStationDataLoading,
  lightningLoadingAgencie: (state) => state.lightningLoadingAgencie
};

export default {
  state,
  mutations,
  actions,
  getters
}
